exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2TluzPpzzkDpV_1wXlhaZp{padding:20px}._2q1odT8zYcjqlp9TchuWrv{cursor:pointer;white-space:nowrap}html[dir] ._3ULGkebpCJ1b-3PahvvF-z{padding-top:10px}", ""]);

// exports
exports.locals = {
	"policyTipPeekContainer": "_2TluzPpzzkDpV_1wXlhaZp",
	"link": "_2q1odT8zYcjqlp9TchuWrv",
	"policyTipButtonContainer": "_3ULGkebpCJ1b-3PahvvF-z"
};